import { EventType } from "./type";

export function getEventBackgroundColor(type: EventType): string {
  switch (type) {
    case "creation":
      return "#e3f2fd"; // light blue
    case "opened":
      return "#f3e5f5"; // light purple
    case "booked":
      return "#e8f5e9"; // light green
    case "clockin":
      return "#e3f2fd"; // light blue
    case "clockout":
      return "#fff3e0"; // light orange
    case "payment":
      return "#e8f5e9"; // light green
    case "rate":
      return "#fffde7"; // light yellow
    case "cancel":
      return "#ffebee"; // light red
    case "unassign":
      return "#fff3e0"; // light orange
    case "note":
      return "#e8eaf6"; // light indigo
    case "shift_spec":
      return "#e1f5fe"; // light cyan
    case "priority":
      return "#f3e5f5"; // light purple
    default:
      return "#f5f5f5"; // light grey
  }
}
